import { loadConfettiPreset } from '@tsparticles/preset-confetti';
import { initParticlesEngine } from '@tsparticles/react';
import { useEffect, useRef, useState } from 'react';

export const useParticles = (step) => {
	const [showParticles, setShowParticles] = useState(false);

	const particlesContainerRef = useRef();

	const particlesLoaded = async (container) => {
		particlesContainerRef.current = container;

		// Create a new interval to check the particles count
		// If there are no particles left, stop the interval and hide the particles
		const interval = setInterval(() => {
			if (container._lifeTime > 0 && container.particles.count === 0) {
				clearInterval(interval);
				setShowParticles(false);
			}
		}, 100);
	};

	useEffect(() => {
		if (step < 2) {
			return;
		}
		initParticlesEngine(async (engine) => {
			await loadConfettiPreset(engine);
		}).then(() => {
			setShowParticles(true);
		});
	}, [step]);

	const emitterOptions = {
		life: {
			count: 1,
			duration: 0.1,
		},
		rate: {
			quantity: 80,
		},
		particles: {
			color: ['#5053c4', '#B749D1', '#FFD662', '#4FF2D1'],
			shape: {
				type: 'edge',
			},
			move: {
				direction: 'top',
			},
			size: {
				value: {
					min: 5,
					max: 10,
				},
			},
			life: {
				count: 1,
				duration: {
					value: 10,
				},
			},
		},
	};

	const particleOptions = {
		emitters: [
			{
				...emitterOptions,
				position: {
					x: 25,
					y: 50,
				},
			},
			{
				...emitterOptions,
				position: {
					x: 50,
					y: 50,
				},
			},
			{
				...emitterOptions,
				position: {
					x: 75,
					y: 50,
				},
			},
		],
		style: {
			position: 'absolute',
			inset: 0,
		},
		preset: 'confetti',
	};

	return { showParticles, particleOptions, particlesLoaded };
};
